module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-8-ni-006.e1c10731.json").toString();